import { AfterViewInit, Component, ElementRef, Input, ViewChild, OnInit, OnDestroy, HostListener } from '@angular/core';
import { zoomMaxValue, zoomMinValue } from '@models/editor';
import { ZoomService } from '@service/canvas/zoom.service';
import { Subject, takeUntil } from 'rxjs';

@Component({
    selector: 'app-zoom-range',
    templateUrl: './zoom-range.component.html',
    styleUrls: ['./zoom-range.component.css'],
    standalone: false,
})
export class ZoomRangeComponent implements OnInit, AfterViewInit, OnDestroy {
    @Input() leftColor: string = 'var(--primary) ';
    @Input() rightColor: string = 'var(--dark-surface-container-highest)';
    @Input() initalValue: number;

    @ViewChild('zoomRange') zoomRange: ElementRef;

    value: number;
    isFocus: boolean;
    minValue: number = zoomMinValue;
    maxValue: number = zoomMaxValue;
    interval: any;

    timeout: any;

    private destroySubscriptionSubject$ = new Subject<void>();

    constructor(private zoomService: ZoomService) {}

    ngOnInit(): void {
        const currentZoom = this.zoomService.getZoom();
        this.value = currentZoom * 100;

        this.zoomService
            .onZoom()
            .pipe(takeUntil(this.destroySubscriptionSubject$))
            .subscribe(zoom => {
                this.value = Math.round(zoom * 100);
                this.updateBackground();
                this.isFocus = true;

                if (this.timeout) {
                    clearTimeout(this.timeout);
                }

                this.timeout = setTimeout(() => {
                    this.isFocus = false;
                    this.timeout = null;
                }, 500);
            });
    }

    ngAfterViewInit(): void {
        this.updateBackground();
    }

    ngOnDestroy(): void {
        this.destroySubscriptionSubject$.next();
        this.destroySubscriptionSubject$.complete();
    }

    updateBackground() {
        if (this.zoomRange.nativeElement) {
            const range = this.maxValue - this.minValue;
            const distanceFromLower = this.value - this.minValue;
            const percentage = ((distanceFromLower / range) * 100).toFixed(2);
            this.zoomRange.nativeElement.style.background = `linear-gradient(to right, ${this.leftColor} 0%, ${this.leftColor} ${percentage}%, ${this.rightColor} ${percentage}%, ${this.rightColor} 100%)`;
        }
    }

    zoomRangeInput(event) {
        const newValue = Number(event?.currentTarget?.value);
        if (newValue) {
            const newZoom = newValue / 100;
            this.zoomService.setZoom(newZoom);
        }
    }

    onMouseUp() {
        clearInterval(this.interval);
        this.interval = null;
    }

    startInterval(event: 'plus' | 'minus') {
        if (this.interval) return;
        this.updateZoom(event);
        this.interval = setInterval(() => {
            this.updateZoom(event);
        }, 100);
    }

    private updateZoom(event: 'plus' | 'minus') {
        if (event === 'minus') {
            if (this.value > this.minValue) {
                let newValue = this.value - 3;
                if (newValue < this.minValue) newValue = this.minValue;
                const newZoom = newValue / 100;
                this.zoomService.setZoom(newZoom);
            }
        } else if (event === 'plus') {
            if (this.value < this.maxValue) {
                let newValue = this.value + 3;
                if (newValue > this.maxValue) newValue = this.maxValue;
                const newZoom = newValue / 100;
                this.zoomService.setZoom(newZoom);
            }
        }
    }
}
